import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2b087b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_3 = { class: "table table-hover align-middle mt-4" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "border-dark border-bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  colspan: 3,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_9 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_PreviewOverviewItem = _resolveComponent("PreviewOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CustomCssPreviewContentBlocksDetail = _resolveComponent("CustomCssPreviewContentBlocksDetail")!
  const _component_BaseOffcanvas = _resolveComponent("BaseOffcanvas")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_title, {
          title: _ctx.$t('customCssPreviews'),
          mb: 3,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.pageUI.isReady())
                ? (_openBlock(), _createBlock(_component_base_modal_button, {
                    key: 0,
                    class: "btn btn-hover icon-link",
                    "modal-id": _ctx.modalId
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                    ]),
                    _: 1
                  }, 8, ["modal-id"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('title')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.pageUI.isReady())
              ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                  key: 0,
                  "n-cols": 3
                }))
              : (!_ctx.hasContentBlocks)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('noContentFound')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.contentBlocks, (contentBlock) => {
                    return (_openBlock(), _createBlock(_component_PreviewOverviewItem, {
                      key: contentBlock.id,
                      onUpdate: _ctx.updateContentBlock,
                      onDelete: _ctx.deleteContentBlock,
                      "content-block": contentBlock,
                      pageUI: _ctx.pageUI
                    }, null, 8, ["onUpdate", "onDelete", "content-block", "pageUI"]))
                  }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_BaseOffcanvas, {
      id: "customCssPreviewDetailOffCanvas",
      title: "Custom CSS",
      label: "Custom CSS",
      class: "offcanvas-wide"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedContentBlockId)
          ? (_openBlock(), _createBlock(_component_CustomCssPreviewContentBlocksDetail, {
              key: _ctx.contentBlockSequence,
              contentBlockId: _ctx.selectedContentBlockId,
              onUpdated: _ctx.reloadContent
            }, null, 8, ["contentBlockId", "onUpdated"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_BaseModal, {
      "modal-id": _ctx.modalId,
      "dialog-classes": "modal-sm",
      title: _ctx.$t('newCustomCssPreview'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_GenericFormWrapper, {
          pageUI: _ctx.pageUI,
          submitData: _ctx.submitData,
          hideFeedbackStatus: ""
        }, {
          content: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.newContentBlock.title!.nl,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newContentBlock.title!.nl) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  modelModifiers: { trim: true },
                  label: _ctx.$t('title'),
                  name: "title",
                  rules: "required|max:255",
                  errors: errors
                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
              ])
            ])
          ]),
          buttons: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              _createVNode(_component_base_modal_button, {
                mode: "close",
                class: "btn btn-outline-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                ]),
                _: 1
              })
            ], true)
          ]),
          _: 3
        }, 8, ["pageUI", "submitData"])
      ]),
      _: 3
    }, 8, ["modal-id", "title"])
  ], 64))
}